<template>
  <div style="width: 100%;">
    <!-- banner -->
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_banner_fir.jpg"
      style="width: 100vw;height: 20vw;margin-top:2px;"
    />

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_cooperate_sec_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_source_sec_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec_1_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec_2_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec_3_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec_4_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec_5_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <!--   业务  bussiness -->
      <div class="bussiness fx-column fx-row-center" style="background:white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">全球化跨境营销的优势</div>
        <div class="blueline"></div>

        <div
          class="fx-row fx-row-top fx-row-space-between"
          style="width: 75vw; margin-top: 3vw; margin-bottom: 4vw;"
        >
          <div class="fx-column fx-row-center" v-for="(item, index) in onearray" v-bind:key="index">
            <img class="bussiness_icon hvr_grow_shadow" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_28'"
              class="bussiness_title"
              style="color:#16214B;"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_14'"
              class="bussiness_des"
              style="color:#515978;"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>

      <!-- #F3F4F6 -->
      <div class="fx-column fx-row-center" style="background:#F3F4F6 ; padding-bottom:4vw; ">
        <div
          :class="ISphone ? smallh1label : bigh1label"
          style="margin-top: 5vw;   width: 100vw; "
        >丰富资源覆盖全球</div>

        <div class="blueline"></div>

        <img
          src="http://pic.midongtech.xyz/yytgw/assets/img_home_img_map.png"
          style="width: 67vw;height: 30vw;margin-top: 6vw;"
        />
      </div>

      <div class="fx-column fx-row-center" style="width:100vw; background: white; ">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">广告形式</div>

        <div class="blueline"></div>

        <div class="fx-row fx-row-top fx-wrap" style="width: 90%;  margin-bottom: 5vw;">
          <div
            class="fx-column fx-row-center"
            style=" margin-top: 2vw; width:33%; background:white; border-radius:4px;"
            v-for="(item, index) in twoarray"
            v-bind:key="index"
          >
            <img
              :src="item.iconurl"
              class="hvr_grow_shadow"
              style="width: 11vw;height: 11vw; margin-bottom:2vw; "
            />
            <div
              :class="ISphone ? smallh3label : 'pxlabel_28'"
              style=" font-weight:middle; width:70%; text-align:center; color:#16214B;"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh3label : 'pxlabel_14'"
              style="margin-top: 1vw; width:70%; text-align:left; color:#515978;"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <contactusview />
  </div>
</template>

<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "GlobalMarketing",
  components: {
    contactusview
    // companybtm,
    //   partner
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      bigh4label: "bigh4label",
      // onearray: [
      //   {
      //     titlestr: "梳理行业现状，深度挖掘品牌定位树立品牌形象，打造有企业特色的品牌IP",
      //     iconurl: "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_fir.png"
      //   },
      //   {
      //     titlestr: "把握新闻热点，制造热门话题，增加品牌公众曝光，引导用户参与线上线下营销活动",
      //     iconurl: "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_sec.png"
      //   },
      //   {
      //     titlestr: "分析受众媒体使用规律，制定有针对性的媒体投放计划并执行落地，达成传播效果",
      //     iconurl: "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_thir.png"
      //   }
      // ],

      onearray: [
        {
          titlestr: "热门媒体全覆盖",
          desstr: "覆盖国内外流行社交及资讯媒体，大量优质人群触手可及",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_fir.png"
        },
        {
          titlestr: "智能化精准投放",
          desstr: "依托大数据及先进分析技术，定向投放广告，提升广告ROI",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec.png"
        },
        {
          titlestr: "全球大数据积累",
          desstr: "业务遍及全球多个国家与地区，立体人群标签",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_thir.png"
        }
      ],
      twoarray: [
        {
          titlestr: "激励视频",
          desstr:
            "短视频广告形式，视听兼备，让用户体验更加出色激励互动形式，以奖励形式促进产品活跃，保障更高的变现收益",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_style_fir.png"
        },
        {
          titlestr: "原生视频",
          desstr:
            "情景植入的方式展示视频广告，不妨碍App的正常使用。预传输加载机制使视频浏览更流畅，提高广告的eCPM和点击率",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_style_sec.png"
        },
        {
          titlestr: "原生信息流",
          desstr:
            "精准人群定向和海量广告资源接入，保障您的App超高广告填充率。以原生的形式完美融入App，保障用户阅读体验的同时实现用户价值最大化",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_style_thir.png"
        },
        {
          titlestr: "原生插屏",
          desstr:
            "插屏作为一种成熟广告样式，拥有信息承载环境纯净表达力强劲的优势，其内容容易吸引用户注意力。Adxmi插屏在视觉上采用原生设计，使用户在观感上有更好的体验",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_style_four.png"
        },
        {
          titlestr: "更多样式",
          desstr:
            "更多视频合作，如果想了解可以留下您的联系方式，我们会安排业务员联系您",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_style_five.png"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.plan {
  background: #f3f4f6;
  width: 100vw;
}

.plantable {
  width: 80vw;
  margin-bottom: 4vw;
}
.plancell {
  width: 25vw;
  height: 30vw;
  background: #ffffff;
  box-shadow: 0 21px 43px 0 rgba(22, 33, 75, 0.15);
  border-radius: 4px;
  padding-top: 1vw;
  padding-bottom: 1vw;
}
.plancell_icon {
  width: 9.43vw;
  height: 9.43vw;
  margin-top: 3vw;
}
.plancell_name {
  margin-top: 1.2vw;
  text-align: center;
  font-weight: middle;
  color: #16214b;
}

.plancell_des {
  margin-top: 1.4vw;
  margin-bottom: 4vw;
  width: 18.2vw;
  text-align: center;
  color: #515978;
}

//

.choosesection {
  width: 100vw;
  // height: 50vw;
  background: #16214b;
}
</style>
